import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import GenericInputStructure from '@/shared-components/inputs/components/GenericInputStructure';
import Text from '@/shared-components/text/components/Text';

import ConfirmClosedMode from './ConfirmClosedMode';

import './styles/ClosedModeForm.css';

export default function ClosedModeForm({ closedModeData }) {
  const { stateHandler } = useStateHandler();
  const t = useTranslations('common.user_settings.closed_mode.form');
  const [formState, setFormState] = useState(closedModeData ? closedModeData.reason : "");
  const [updateMessageLoading, setUpdateMessageLoading] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

  function updateClosedMode(newClosedMode) {
    stateHandler.set("user_session.gallery_closed", newClosedMode);

    if(newClosedMode) {
      setFormState(newClosedMode.reason);
    } else {
      setFormState("");
    }
  }

  async function updateMessage() {
    setUpdateMessageLoading(true);

    const { response, data } = await GalleryService.updateClosedMode(true, formState);

    if(response.ok) {
      setUpdateMessageLoading(false);
      updateClosedMode(data);
    }
  }

  return (
    <>
      <form onSubmit={e=>e.preventDefault()} className="settings-closed-mode__form">
        <GenericInputStructure element="custom_message" placeholder={t('custom_message_label')}>
          <textarea 
            name="custom_message" 
            id="custom_message"
            value={formState}
            onChange={e=>setFormState(e.target.value)}
            placeholder={t('custom_message_placeholder')}
            className="settings-closed-mode__textarea font-size-medium"
            spellCheck={false}
            autoComplete="off"
          />
        </GenericInputStructure>

        {
          closedModeData ?
            <Text
              className="settings-closed-mode__form-text font-size-small"
              paragraph
              justify>
              {t('status.closed')}
            </Text>
            :
            <Text
              className="settings-closed-mode__form-text font-size-small"
              paragraph
              justify>
              {t('status.opened')}
            </Text>
        }

        {/* <Text className="settings-closed-mode__form-text" small>
                    <span>Remaining:</span> {fetchData.days_remaining} {fetchData.days_remaining === 1 ? "day" : "days"}
                </Text> */}

        <div className="settings-closed-mode__buttons">
          <ContinueButton className="font-size-medium" onClick={()=>setOpenConfirmationDialog(true)}>
            {
              closedModeData ?
                t('buttons.open')
                :
                t('buttons.close')
            }
          </ContinueButton>

          {(Boolean(closedModeData) && closedModeData.reason !== formState) && (
            <ContinueButton 
              className="font-size-medium margin" 
              loading={updateMessageLoading}
              onClick={updateMessage}
            >
              {t('buttons.update_message')}
            </ContinueButton>
          )}
        </div>
      </form>
      <ConfirmClosedMode
        open={openConfirmationDialog}
        close={()=>setOpenConfirmationDialog(false)}
        formState={formState}
        closedModeData={closedModeData}
        updateClosedMode={updateClosedMode}
      />
    </>
  );
}
